module.exports = "<app-stickynav></app-stickynav>\r\n<router-outlet></router-outlet>\r\n<app-footer></app-footer>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// E:/Angular/website-angular/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main